// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    GetManagementGroupOptionsApiParameter,
    ManagementGroupOptionsModel,
    updateManagementGroupDetails as updateManagementGroupDetailsService,
} from "@guestsupply/App/Services/ManagementGroupOptionsService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    GetManagementGroupOptionsApiParameter & HasOnSuccess & HasOnError<string>,
    ServiceResult<ManagementGroupOptionsModel> & {
        errorMessage?: string;
    }
>;

export const CallUpdateManagementGroupDetailsApi: HandlerType = async props => {
    const updatedManagementGroupDetailsResult = await updateManagementGroupDetailsService({
        name: props.parameter.name,
        details: props.parameter.details,
    });
    props.apiResult = updatedManagementGroupDetailsResult;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const chain = [CallUpdateManagementGroupDetailsApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const updateManagementGroupDetails = createHandlerChainRunner(chain, "updateManagementGroupDetails");
export default updateManagementGroupDetails;
